module.exports = __webpack_public_path__ + "media/src/images/top_covers/5nighttown-2df1801ec3920fb42762f75cdb046d7a.png";